
module MapDrawing {
    import ObservableValue = spt.Utils.ObservableValue;

    export class ViewModel {

        constructor(mapDrawer: MapDrawer, view: Element, editorMode: number) {
            ko.track(this);
            
            this.init(mapDrawer, view, editorMode);

            this.UseImperialSystem = window.UseImperialSystem;
            this.usemeteronroof = window.usemeteronroof;

            this.valueAdjustOpts = {
                notImperial: true,
                precision: window.UseImperialSystem || window.usemeteronroof ? 3 : 0,
                from: "mm",
                to: window.UseImperialSystem ? "ft" : (window.usemeteronroof ? "m" : "mm")
            };

            this.slopeAdjustOpts = {
                notImperial: true,
                precision: 3
            };

            this.scaleAdjustOpts = {
                notImperial: true,
                precision: 2,
                scale: 100
            };

            this.rotateAdjustOpts = {
                notImperial: true,
                precision: 2
            };

            ko.defineProperty(this, 'detailsIconOffset', () => {
                return !this.detailsViewVisible ? `-${1 * 20}px -${2 * 20}px` : `-${0 * 20}px -${2 * 20}px`;
            });

            ko.defineProperty(this, 'currentLayer',
                {
                    get: () => {
                        return this.layer.typeName[this.selectedLayerTypeName] || this.layer.referenceLayer;
                    },
                    set: (p: PolygonLayer) => {
                        this.selectedLayerTypeName = p ? p.typeName : null;
                    }
                });

            ko.defineProperty(this, 'buildings3dDataAvailable', {
                get: () => this._buildings3dDataAvailable,
                set: (value: boolean) => this._buildings3dDataAvailable = value
            });

            ko.defineProperty(this, "bounds", () => {
                var layers = this.layer.all;
                var bounds: BoundsLatLng = null;
                layers.forEach(layer => {
                    var bd = layer.bounds;
                    if (bd) {
                        if (bounds)
                            bounds.Expand(bd);
                        else
                            bounds = new BoundsLatLng(bd.Min, bd.Max);
                    }
                });
                return bounds || new BoundsLatLng();
            });

            ko.defineProperty(this, "currentImportedImage", () => {
                if (!this.currentImportedImageId)
                    return this.importedImages.length ? this.importedImages[0] : null;
                for (var i = 0, j = this.importedImages.length; i < j; i++) {
                    var img = this.importedImages[i];
                    if (img._id === this.currentImportedImageId)
                        return img;
                }
                return null;
            });

            ko.defineProperty(this, "referenceLatLng", () => {
                var layer = this.layer.referenceLayer;
                var bd = layer.bounds;
                if (layer.polygons.length) {
                    var data = layer.polygons[0].userData as ShapeData;
                    if (data && data.southMarker && data.southMarker.orientation)
                        return LatLng.FromPoint2D(data.getOrientedOrigin());
                }
                if (bd && bd.Initialized)
                    return layer.bounds.Min;
                return this.mapDrawer.center;
            });

            ko.defineProperty(this, "referenceOrientation", () => {
                var layer = this.layer.referenceLayer;
                if (layer.polygons.length) {
                    var data = layer.polygons[0].userData as ShapeData;
                    if (data && data.southMarker && data.southMarker.orientation)
                        return data.southMarker.orientation;
                }
                return 0;
            });

            ko.defineProperty(this, "referenceMarker", () => {
                var latLng = this.referenceLatLng,
                    orientation = this.referenceOrientation,
                    refMarker = this._referenceMarker,
                    mapDrawer = this.mapDrawer;

                if (!mapDrawer.map || !latLng)
                    return null;

                var vx = Point2D.FromOrientation(-orientation).mul(20),
                    vy = vx.rot90(),
                    r = 14,
                    r2 = r * 2,
                    ps = `M${-r},0 a${r},${r} 0 0,0 ${r2},0 a${r},${r} 0 0,0 ${-r2},0 M${-vx.x},${-vx.y} L${vx.x},${vx.y} M${-vy.x},${-vy.y} L${vy.x},${vy.y}`,
                    opts: google.maps.MarkerOptions = {
                        position: latLng.ToGMLatLng(),
                        icon: {
                            path: ps,
                            strokeWeight: 1,
                            strokeColor: "rgb(179,255,255)",
                            strokeOpacity: 0.7
                        }
                    };

                if (!refMarker) {
                    refMarker = this._referenceMarker = new google.maps.Marker($.extend({
                        clickable: false,
                        draggable: false,
                        map: mapDrawer.map,
                        zIndex: 0,
                        visible: true
                    }, opts));
                } else {
                    refMarker.setOptions(opts);
                }

                return refMarker;
            });

            ko.getObservable(this, "referenceMarker").subscribe((v) => {
                //this function is needed! Even when it does nothing, we need a subscriber so knockout updates the referenceMarker when it changes.
            });

            ko.defineProperty(this, "referenceAxis", () => {
                return Point2D.FromOrientation(this.referenceOrientation);
            });

            ko.defineProperty(this, "saveDisabled", () => {
                return false;
            });

            ko.defineProperty(this, "uploadDisabled", () => {
                return false;
            });

            ko.getObservable(this, "selection").subscribe(this.onSelectionChanged.bind(this), null, "arrayChange");

            ko.getObservable(this, "showCoords").subscribe((v) => {
                if (this.layer.building)
                    this.layer.building.forceUpdateAllPolygons();
                if (this.layer.interference)
                    this.layer.interference.forceUpdateAllPolygons();
                if (this.layer.freeArea)
                    this.layer.freeArea.forceUpdateAllPolygons();
            });

            ko.getObservable(this, "showLengths").subscribe((v) => {
                if (this.layer.building)
                    this.layer.building.forceUpdateAllPolygons();
                if (this.layer.interference)
                    this.layer.interference.forceUpdateAllPolygons();
                if (this.layer.freeArea)
                    this.layer.freeArea.forceUpdateAllPolygons();
            });

            ko.getObservable(this, "showCoordNumbers").subscribe((v) => {
                if (this.layer.building)
                    this.layer.building.forceUpdateAllPolygons();
                if (this.layer.interference)
                    this.layer.interference.forceUpdateAllPolygons();
                if (this.layer.freeArea)
                    this.layer.freeArea.forceUpdateAllPolygons();
            });

            ko.getObservable(this, "showAngle").subscribe((v) => {
                if (this.layer.building)
                    this.layer.building.forceUpdateAllPolygons();
                if (this.layer.interference)
                    this.layer.interference.forceUpdateAllPolygons();
                if (this.layer.freeArea)
                    this.layer.freeArea.forceUpdateAllPolygons();
            });

            ko.defineProperty(this, 'toolsDisabled',
                {
                    get: () => {
                        return this.allTools.every(t => t.disabled);
                    },
                    set: (b: boolean) => {
                        this.allTools.forEach(t => { t.disabled = !!b; });
                    }
                });
            ko.getObservable(this, "showCoordinatesInfoWindow").subscribe((val) => {
                
                var projectCoordinates = new google.maps.LatLng(this.mapDrawer.center.Latitude, this.mapDrawer.center.Longitude);
                // initialize marker only once, create marker with project latLng
                if (!this._projectMarker) {
                    this._projectMarker = new google.maps.Marker({
                        position: projectCoordinates,
                    });
                   
                    var projectInfoWindow = new google.maps.InfoWindow();

                    this._projectMarker.addListener('click', (event) => {
                        projectInfoWindow.open(this.mapDrawer.map, this._projectMarker);
                    });

                    this.getAddressfromPosition(projectCoordinates, (geocoderResults) => {
                        var formattedAddress = 'Cannot determine address at this location.';
                        if (geocoderResults && geocoderResults.length > 0) {
                            formattedAddress = geocoderResults[0].formatted_address;
                        }

                        // set content to projectInfoWindow
                        var info = formattedAddress + "<br>coordinates: " + this._projectMarker.getPosition().toUrlValue(6)
                        projectInfoWindow.setContent(info);
                    });
                }
                
                if (val) {
                    // show project marker
                    this._projectMarker.setMap(this.mapDrawer.map);
                    
                    var recalculatedBuildingBounds = this.mapDrawer.getBoundsFromPolygons(this.layer.building.polygons);
                    if (recalculatedBuildingBounds.isEmpty()) {
                        var projectCoordinatesMetric = LatLng.FromGMLatLng(projectCoordinates);
                        var extendedBounds = new BoundsLatLng(projectCoordinatesMetric, projectCoordinatesMetric);
                        var offsetInMeters = 50;
                        extendedBounds = extendedBounds.Extend(offsetInMeters);
                        recalculatedBuildingBounds = extendedBounds.ToGMLatLngBounds();
                    }
                    this.mapDrawer.map.fitBounds(recalculatedBuildingBounds);
                }
                else {
                    // hide project marker
                    this._projectMarker.setMap(null);                  
                }
            });

            this.keyBoardSteps = new ObservableValue(100, { internalUnit: "mm", viewUnit: UseImperialSystem ? "in" : "mm", precision: 2 });
            this.interferenceLineThickness = new ObservableValue(250, { internalUnit: "mm", viewUnit: UseImperialSystem ? "in" : "mm", precision: 2 });

            if ($(".mdDetailsContent").length) {
                var mdDetailsContent = $(".mdDetailsContent").get(0) as HTMLDivElement;

                document.addEventListener("mousedown", (ev) => {
                    this.detailsContentHasFocus = false;
                }, true);

                mdDetailsContent.addEventListener("mousedown", (ev) => {
                    this.detailsContentHasFocus = true;
                }, true);
            }
        }

        //offsetCenter(latlng, offsetx, offsety) {

        //    // latlng is the apparent centre-point
        //    // offsetx is the distance you want that point to move to the right, in pixels
        //    // offsety is the distance you want that point to move upwards, in pixels
        //    // offset can be negative
        //    // offsetx and offsety are both optional

        //    var scale = Math.pow(2, this.mapDrawer.map.getZoom());

        //    var worldCoordinateCenter = this.mapDrawer.map.getProjection().fromLatLngToPoint(latlng);
        //    var pixelOffset = new google.maps.Point((offsetx / scale) || 0, (offsety / scale) || 0);

        //    var worldCoordinateNewCenter = new google.maps.Point(
        //        worldCoordinateCenter.x - pixelOffset.x,
        //        worldCoordinateCenter.y + pixelOffset.y
        //    );

        //    var newCenter = this.mapDrawer.map.getProjection().fromPointToLatLng(worldCoordinateNewCenter);

        //    this.mapDrawer.map.setCenter(newCenter);

        //}

        clear() {
            this.layer.all.forEach(layer => {
                this.mapDrawer.deleteSelectables(layer.polygons.map(poly => poly.userData as ShapeData));
            });
            this.helperLines.removeAll().forEach(helperLine => {
                helperLine.dispose();
            });
            this.importedImages.removeAll().forEach(im => {
                im.setMap(null);
            });
            if (this._referenceMarker) {
                this._referenceMarker.setMap(null);
                this._referenceMarker = null;
            }
        }

        init(mapDrawer: MapDrawer, view: Element, editorMode: number) {
            this.mapDrawer = mapDrawer;
            this.view = view;
            this.editorMode = editorMode || 0;
            if (this._referenceMarker) {
                this._referenceMarker.setMap(null);
                this._referenceMarker = null;
            }

            if (this.multiShapeData === undefined) {
                var multiShapeData: MultiShapeData = null;
                Object.defineProperty(this, 'multiShapeData',
                    {
                        configurable: true,
                        enumerable: true,
                        get: () => {
                            if (!multiShapeData)
                                multiShapeData = new MultiShapeData(this.mapDrawer);
                            return multiShapeData;
                        }
                    });
            }

            this.layer = new LayerHolder(mapDrawer, this.editorMode);

            this.toolIcons = {};
            this.allTools.removeAll();

            //tools
            Object.keys(MapDrawing).filter((n) => typeof MapDrawing[n] === "function" && (<any>MapDrawing[n]).prototype instanceof BaseToolIcon).forEach(n => {
                this.allTools.push(this.toolIcons[n] = new MapDrawing[n](mapDrawer, n) as BaseToolIcon);
            });

            if (this.selection.length)
                this.selection.removeAll();
            if (this.importedImages.length)
                this.importedImages.removeAll();

            this.selectedLayerTypeName = null;
            this.isReadOnly = mapDrawer.options.isReadOnly;
            this.selectedToolName = this.isReadOnly ? 'HandTool' : 'SelectTool';
            this.slideOutVisible = false;
            this.viewWidth = 0;
            this.viewHeight = 0;
            this.currentImportedImageId = null;
            this.detailsViewVisible = false;
        }

        get currentTool(): BaseToolIcon {
            return this.toolIcons[this.selectedToolName || 'SelectTool'];
        }

        set currentTool(v: BaseToolIcon) {
            this.selectedToolName = (v ? v.name : 'SelectTool') || 'SelectTool';
        }

        editorMode: number = 0;
        layer: LayerHolder = null;
        instances: { [id: string]: ISelectableItem } = {};
        selection: ISelectableItem[] = [];
        multiShapeData: MultiShapeData;
        currentLayer: PolygonLayer;
        selectedLayerTypeName: string = null;
        toolIcons: { [name: string]: BaseToolIcon };
        allTools: BaseToolIcon[] = [];
        isReadOnly: boolean = false;
        selectedToolName: string = 'SelectTool';
        isDragging: boolean = false;
        detailsContentHasFocus: boolean = false;
        mapDrawer: MapDrawer;
        view: Element;
        slideOutVisible = false;
        viewWidth = 0;
        viewHeight = 0;
        importedImages: ImageMapOverlay[] = [];
        currentImportedImageId: string = null;
        currentImportedImage: ImageMapOverlay;
        referenceLatLng: LatLng;
        private _projectMarker: google.maps.Marker;
        referenceAxis: Point2D;
        referenceOrientation: number;
        private _referenceMarker: google.maps.Marker;
        private _idleListener: google.maps.MapsEventListener;
        referenceMarker: google.maps.Marker;
        bounds: BoundsLatLng;
        initialBounds: google.maps.LatLngBounds | null = null;
        helperLines: Helperline[] = [];
        readonly keyBoardSteps: ObservableValue;
        readonly interferenceLineThickness: ObservableValue;
        hoveredId: string = null;
        toolsDisabled: boolean;
        dragInfo: {
            id: string;
            start: Point2D;
            lastLatLng: LatLng;
            firstLatLng: LatLng;
            active: boolean;
            initialPath: google.maps.LatLng[][];
        } = null;
        cmdInputVal = "";
        cmdEdgeLength = 0;
        showCoords = false;
        showAngle = false;
        showAngleWhileDrawing = true;
        showLengths = true;
        showCoordNumbers = false;
        coordsRelative = false;
        enableDepthCalculation = false;
        showCoordinatesInfoWindow: boolean = false;
        mapDrawerRenderCallback: () => void;
        private _geocoder: google.maps.Geocoder;
        drawnCircles = new Set<string>();
        isNewGis3DBuilding:boolean = false;
        isDrawingMode = true;
        private _buildings3dDataAvailable = false;
        isMultiRoof: boolean = true;
        isBuildingOutOfView: boolean = false;

        clearDrawnCircles() {
            this.drawnCircles.clear();
        }
        
        afterMapDrawerRender() {
            if(this.mapDrawerRenderCallback)
                this.mapDrawerRenderCallback();
        }

        getAddressfromPosition(position: google.maps.LatLng, responseCallback: (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => void) {
            if (!this._geocoder) {
                this._geocoder = new google.maps.Geocoder();
            }

            this._geocoder.geocode({
                location: position
            }, responseCallback);
        }

        toggleOsmTool(b: boolean) {
            this.mapDrawer.selectTool(b ? "OsmBuildingsTool" : null);
        }
        
        toggleGis3DBuildingsTool(gis3DBuildings: boolean) {
            const corrCtrl = (this.mapDrawer as any).correctionRightAngleControl as JQuery | null;
            if (gis3DBuildings) {
                $('#slopeForAllRoofs').addClass("hidden");
                this.isDrawingMode = false;
                this.showLengths = false;
                if (this.layer.building) {

                    this.layer.building.maxCount = 0;
                }
                this.mapDrawer.deleteAll();
                corrCtrl?.addClass('d-none');
            }
            else {
                $('#slopeForAllRoofs').removeClass("hidden");
                this.isDrawingMode = true;
                this.showLengths = true;
                if (this.layer.building) {
                    this.layer.building.maxCount = 0;
                }
                this.mapDrawer.deleteAll();
                corrCtrl?.removeClass('d-none');
            }
                
            this.mapDrawer.selectTool(gis3DBuildings ? "Gis3DBuildingsTool" : "DrawTool")
        }
        
        moveToProjectAddress() {
            const projectLocation = this.mapDrawer.center;

            // move viewport/camera to location
            this.mapDrawer.center.set(projectLocation.Latitude, projectLocation.Longitude);
            this.mapDrawer.map.setCenter(projectLocation.ToGMLatLng());
            this.mapDrawer.map.setZoom(window.innerWidth < 768 ? 19 : 20);
        }

        registerMapListeners(map: google.maps.Map) {
            if (this._idleListener) {
                google.maps.event.removeListener(this._idleListener);
                this._idleListener = null;
            }
            this._idleListener = map.addListener('idle', () => this._checkBuildingOutOfView());
        }

        private _checkBuildingOutOfView() {
            const mapBounds = this.mapDrawer?.map?.getBounds();
            let outOfView = this.mapDrawer.map.getZoom() < 19;
            
            if (!outOfView && mapBounds) {
                const polys = [
                    ...(this.layer?.building?.polygons ?? []),
                    ...(this.layer?.roof?.polygons ?? [])
                ];

                if (polys.length) {
                    const polyBounds = this.mapDrawer.getBoundsFromPolygons(polys);
                    if (!polyBounds.isEmpty()) {
                        outOfView = !mapBounds.intersects(polyBounds);
                    } else {
                        const c = this.mapDrawer.center;
                        outOfView = !mapBounds.contains({ lat: c.Latitude, lng: c.Longitude });
                    }
                } else {
                    const c = this.mapDrawer.center;
                    outOfView = !mapBounds.contains({ lat: c.Latitude, lng: c.Longitude });
                }
            }

            const focusVisibilityChanged = this.isBuildingOutOfView !== outOfView;
            this.isBuildingOutOfView = outOfView;
             
            if (this.mapDrawer.goToProjectBtn){
                this.mapDrawer.goToProjectBtn.hidden = !outOfView;
            }

            if (focusVisibilityChanged) {
                (window as any).lsJsInvokable?.getRefreshRoofStep?.()?.invokeMethodAsync?.('SetProjectLocationFocusVisible', outOfView);
            }
        }

        setEdgeLength(v: number | string) {
            var l = spt.Utils.GetFloatFromInputValue("" + v,
                {
                    min: 0,
                    max: 1000000,
                    precision: 0,
                    applyArithmetic: true,
                    isFeet: window.UseImperialSystem,
                    notImperial: !window.UseImperialSystem,
                    from: this.valueAdjustOpts.to,
                    to: "mm"
                });

            this.cmdEdgeLength = l;
        }

        onCommandEnter(input: HTMLInputElement) {
            var $input = $(input);

            var cmd = "" + $input.val();

            if (this.selectedToolName === 'DrawTool')
                this.currentTool.onCommandText(this.mapDrawer, cmd);

            setTimeout(() => {
                $input.val("");
                this.cmdInputVal = "";
            }, 0);

            $input.focus();
        }
        //setKeyBoardSteps(v: string | number) {
        //    this.keyBoardSteps = spt.Utils.GetFloatFromInputValue("" + v,
        //        {
        //            min: 0,
        //            max: 1000000,
        //            applyArithmetic: true,
        //            isFeet: window.UseImperialSystem,
        //            notImperial: !window.UseImperialSystem,
        //            from: this.valueAdjustOpts.to,
        //            to: "mm"
        //        });
        //}

        setInstance(id: string, item: ISelectableItem) {
            this.instances[id] = item;
            ko.valueHasMutated(this, 'instances');
        }

        hasInstance(id: string) {
            return !!this.instances[id];
        }

        removeInstance(id: string) {
            if (this.instances[id]) {
                delete this.instances[id];
                ko.valueHasMutated(this, 'instances');
            }
        }

        foreachSelected(fn: (s: ISelectableItem) => void, excludeId?: string, includeLocked?: boolean): void {
            this.selection.forEach(sel => {
                if (!sel._isDisposed && sel.id !== excludeId && (!sel.locked || includeLocked))
                    fn(sel);
            });
        }

        foreachItem(fn: (s: ISelectableItem) => void, excludeId?: string, includeLocked?: boolean): void {
            var layers = this.layer.all;

            for (var i = 0, j = layers.length; i < j; i++) {
                var layer = layers[i];
                layer.polygons.forEach(sel => {
                    if (!sel._isDisposed && sel.userData && sel.userData.id !== excludeId && (!sel.userData.locked || includeLocked))
                        fn(sel.userData as ShapeData);
                });
            }

            this.helperLines.forEach(sel => {
                if (!sel._isDisposed && sel.id !== excludeId)
                    fn(sel);
            });
        }

        currentSubViewModel: ISubModelView = null;

        saveDisabled: boolean;
        uploadDisabled: boolean;

        detailsViewVisible: boolean = false;
        detailsIconOffset: string;
        showOverlay = false;
        isFacade = false;
        buildings3dDataAvailable: boolean = false;

        UseImperialSystem: boolean;
        usemeteronroof: boolean;
		rightAngleRoofCorrectionIsDefaultOn: boolean;

        slopeAdjustOpts: spt.Utils.IFloatFromInputOptions;
        valueAdjustOpts: spt.Utils.IFloatFromInputOptions;
        scaleAdjustOpts: spt.Utils.IFloatFromInputOptions;
        rotateAdjustOpts: spt.Utils.IFloatFromInputOptions;

        toggleSlideOut() {
            this.slideOutVisible = !this.slideOutVisible;
        }

        setSlideOutVisible(v) {
            this.slideOutVisible = !!v;
        }

        selectLayer(layer: PolygonLayer) {
            this.selectedLayerTypeName = layer ? (layer.typeName || null) : null;
        }

        selectLayerByTypeName(layerTypeName: string) {
            this.selectedLayerTypeName = layerTypeName || null;
        }

        viewLayer(layer: PolygonLayer) {
            this.mapDrawer.fitBounds(layer.polygons);
        }

        toggleDetailsPane() {
            this.detailsViewVisible = !this.detailsViewVisible;
        }

        beginFileUpload(data: any, ev: Event) {
            var input = (ev.target || ev.srcElement) as HTMLInputElement;

            if (!input || !input.value)
                return;

            this.mapDrawer.selectTool("SelectTool");

            AManager.UploadFile(input, "Dach", "UploadCADOrImageFileForDrawing", { paramName: 'fileBase'}, (result: any) => {
                if (!result || result.ErrorCode) {
                    DManager.showErrorMessage("ErrorCode: " + result.ErrorCode);
                    return;
                }

                this.mapDrawer.load();

                input.value = null;
            });
        }

        onSelectionChanged(changes: { value: ISelectableItem, status: string }[]) {
            var multiShapeData = this.multiShapeData;

            changes.forEach((change) => {
                var item = change.value;
                if (item && !item._isDisposed && item instanceof ShapeData) {

                    switch (change.status) {
                        case "deleted":
                            multiShapeData.shapeDatas.remove(im => im.id === item.id);
                            break;
                        case "added":
                            multiShapeData.shapeDatas.push(item);
                            break;
                    }
                }
            });

            multiShapeData.detailsViewVisible = false;

            multiShapeData.updateStyle();
        }

        onSelectableClick(selectable: MapDrawing.ISelectableItem, ev: google.maps.MouseEvent) {
            var mapDrawer = this.mapDrawer;
            if (this.isDragging)
                return;

            if (mapDrawer.viewModel.selectedToolName === 'SelectTool' && selectable && !selectable.locked) {
                this.hoveredId = selectable.id;
                selectable.hovered = true;
                mapDrawer.doSelectSelectable(selectable);
                if (selectable instanceof ShapeData && selectable.children.length && ev.latLng)
                    selectable.selectChildren(LatLng.FromGMLatLng(ev.latLng));
            }
            else if (mapDrawer.viewModel.selectedToolName === 'EraserTool' && selectable && !selectable.locked)
                mapDrawer.deleteSelectable(selectable);

        }

        cleanUpDragInfo() {
            if (this.dragInfo)
                this.dragInfo = null;
        }

        onSelectableMouseover(selectable: MapDrawing.ISelectableItem) {
            if (selectable) {
                this.hoveredId = selectable.id;
                if (this.selectedToolName === 'SelectTool' && selectable && !selectable.locked && !this.isDragging)
                    selectable.hovered = true;
            }

        }

        onSelectableMouseout(selectable: MapDrawing.ISelectableItem) {
            if (selectable) {
                if (this.hoveredId === selectable.id)
                    this.hoveredId = null;
                if (this.selectedToolName === 'SelectTool' && selectable && !selectable.locked && !this.isDragging)
                    selectable.hovered = false;
            }
        }

        onPolygonMousedown(poly: IGoogleMapsPolygon, ev: MouseEvent) {
            var dragInfo = this.dragInfo;

            if (dragInfo) {
                let shapeData = (<ShapeData>this.instances[dragInfo.id]);

                if (dragInfo.active && !shapeData._isDisposed)
                    this.onPolygonDragEnd(shapeData.poly);

                this.cleanUpDragInfo();
            }

            if (poly && !poly._isDisposed && this.selectedToolName === 'SelectTool' && poly.userData) {

                let data = poly.userData as ShapeData,
                    latLng = LatLng.FromGMLatLng(this.mapDrawer.GetLatLngFromMouseEvent(ev)),
                    start = latLng.ToPoint2D();

                // Drawing mode: whole-shape dragging goes through the roof-pill move handle only
                if (this.isDrawingMode && (data.typeName === window.RoofTypeName || data.typeName === window.BuildingTypeName)) {
                    return;
                }

                if (data instanceof ShapeData && data.selected && !data.isOnEdgePoint(start)) {
                    const initialPath = poly.getPaths().getArray().map(p => p.getArray());
                    this.dragInfo = {
                        id: poly.userData.id,
                        start: start,
                        lastLatLng: latLng,
                        firstLatLng: latLng,
                        active: false,
                        initialPath,
                    };

                    ev.preventDefault();
                    ev.stopPropagation();
                }
            }
        }

        onMousemove(ev: MouseEvent) {
            var dragInfo = this.dragInfo;
            if (dragInfo) {
                let mapDrawer = this.mapDrawer,
                    shapeData = (<ShapeData>this.instances[dragInfo.id]);

                if (!dragInfo.active && mapDrawer.GetPoint2DFromMouseEvent(ev).sub(dragInfo.start).mul(mapDrawer.getPixelFactor()).GetLengthSquared() > 100) {
                    dragInfo.active = true;
                    this.onPolygonDragStart(shapeData.poly);
                }
                if (dragInfo.active && !shapeData._isDisposed) {
                    var curLatLng = LatLng.FromGMLatLng(this.mapDrawer.GetLatLngFromMouseEvent(ev));

                    if (mapDrawer.shiftDown) {
                        var snap = Helperline.GetSnapByHelperlines(null, dragInfo.firstLatLng, curLatLng, mapDrawer, true, false);
                        curLatLng = snap.result;
                    }

                    shapeData.moveByLatLng(curLatLng.sub(dragInfo.lastLatLng));

                    this.onPolygonDragged(shapeData.poly);

                    dragInfo.lastLatLng = curLatLng;
                }
            }
        }

        onMouseup(ev: MouseEvent) {
            var dragInfo = this.dragInfo;

            if (dragInfo) {
                let shapeData = (<ShapeData>this.instances[dragInfo.id]);

                if (dragInfo.active && !shapeData._isDisposed) {
                    this.onPolygonDragEnd(shapeData.poly);

                    ev.preventDefault();
                    ev.stopPropagation();
                }

                this.dragInfo = null;
            }
        }

        onPolygonDragStart(poly: IGoogleMapsPolygon) {
            this.isDragging = true;

            if (poly._isDisposed)
                return;

            poly.setOptions({
                editable: false,
                draggable: false
            });

            var data = poly.userData as ShapeData,
                paths = poly.getPaths();

            if (!data || !paths || !paths.getLength())
                return;

            var path = paths.getAt(0);

            if (path && path.getLength()) {
                data.dragPosition = LatLng.FromGMLatLng(path.getAt(0));

                if (data.typeName === window.BuildingTypeName)
                    this.foreachItem(sel => {
                        if (sel instanceof ShapeData)
                            sel.poly.setOptions({
                                editable: false,
                                draggable: false
                            });
                    }, data.id);
                else
                    this.foreachSelected(sel => {
                        if (sel instanceof ShapeData)
                            sel.poly.setOptions({
                                editable: false,
                                draggable: false
                            });
                    }, data.id);
            }

            //#region strg copy

            if (this.mapDrawer.ctrlDown && data instanceof ShapeData && data.selected) {

                var viewModel = this;
                var dataLayer = viewModel.layer.typeName[data.typeName];

                if (!dataLayer.controlledByParent && !dataLayer.locked) {
                    var tempData: PolyData[] = this.mapDrawer.tempPolyData = [PolyData.fromShapeData(data, spt.Utils.GenerateGuid())];

                    this.foreachSelected(sel => {
                        if (sel instanceof ShapeData) {
                            let layer = viewModel.layer.typeName[sel.typeName];
                            if (!layer.controlledByParent && !layer.locked) {
                                tempData.push(PolyData.fromShapeData(sel, spt.Utils.GenerateGuid()));
                            }
                        }
                    }, data.id);
                }

            }

            //#endregion
        }

        onPolygonDragged(poly: IGoogleMapsPolygon) {
            if (poly._isDisposed)
                return;

            var data = poly.userData as ShapeData,
                paths = poly.getPaths();

            if (!data || !paths || !paths.getLength())
                return;

            //#region strg copy

            if (this.mapDrawer.ctrlDown && data instanceof ShapeData && data.selected && this.mapDrawer.tempPolyData.length) {
                var viewModel = this;
                var dataLayer = viewModel.layer.typeName[data.typeName];

                if (!dataLayer.controlledByParent && !dataLayer.locked) {
                    var counterOfPolygonsWithSameBaseTitle: { [typeAndTitle: string]: number } = {};

                    viewModel.foreachSelected(sel => {
                        if (sel instanceof ShapeData) {
                            let layer: PolygonLayer = viewModel.layer.typeName[sel.typeName];
                            if (!layer.controlledByParent && !layer.locked) {

                                let originalShapeTitle: string = sel.title;
                                let originalShapeTitleSplitted: string[] = originalShapeTitle.split(" ");

                                let baseTitle: string = originalShapeTitle; // baseTitle - Title without number at the end: e.g. Störfläche instead of Störfläche 04.

                                if (originalShapeTitleSplitted.length > 1) {
                                    let lastElementOfSplittedTitle = originalShapeTitleSplitted[originalShapeTitleSplitted.length - 1];

                                    if (layer.isNumber(lastElementOfSplittedTitle)) {
                                        originalShapeTitleSplitted.pop(); //delete last element, if it is number.
                                        baseTitle = originalShapeTitleSplitted.join(" ");
                                    }
                                }
                                        
                                if (!counterOfPolygonsWithSameBaseTitle[sel.typeName + "_" + baseTitle]) {
                                    let counterSameBaseTitle: number = layer.polygons.filter(polygon => {
                                        let polygonTitle: string = polygon.userData.title;
                                        let polygonTitleSplitted: string[] = polygonTitle.split(" ");

                                        let basePolygonTitle: string = polygonTitle;
                                        if (polygonTitleSplitted.length > 1) {
                                            let lastElementOfSplittedPolygonTitle = polygonTitleSplitted[polygonTitleSplitted.length - 1];

                                            if (layer.isNumber(lastElementOfSplittedPolygonTitle)) {
                                                polygonTitleSplitted.pop();
                                                basePolygonTitle = polygonTitleSplitted.join(" ");
                                            }
                                        }

                                        if ((basePolygonTitle === baseTitle) && (polygon.userData.typeName === sel.typeName))
                                            return polygon;

                                    }).length;

                                    counterOfPolygonsWithSameBaseTitle[sel.typeName + "_" + baseTitle] = counterSameBaseTitle;
                                }

                                sel.title = layer.getNewName(++counterOfPolygonsWithSameBaseTitle[sel.typeName + "_" + baseTitle], baseTitle);

                            }
                        }
                    });

                    this.mapDrawer.tempPolyData.forEach(data => {
                        this.mapDrawer.addPolygonByData(data);
                    });
                }

                this.mapDrawer.tempPolyData = [];
            }

            //#endregion

            var path = paths.getAt(0);

            if (path && path.getLength() && data.dragPosition) {
                var curpos = LatLng.FromGMLatLng(path.getAt(0)),
                    delta = curpos.sub(data.dragPosition);

                if (data.typeName === window.BuildingTypeName)
                    this.foreachItem(sel => {
                        sel.moveByLatLng(delta);
                    }, data.id);
                else
                    this.foreachSelected(sel => {
                        sel.moveByLatLng(delta);
                    }, data.id);

                data.dragPosition = curpos;
            }
        }

        onPolygonDragEnd(poly: IGoogleMapsPolygon) {
            setTimeout(() => { this.isDragging = false; }, 0);
            this.mapDrawer.tempPolyData = [];
            const dragInfo = this.dragInfo;

            const userDataUpdate = () => {
                if (poly.userData as ShapeData) {
                    poly.userData.update();
                    poly.userData.hovered = false;
                }
            }

            if (poly._isDisposed) {
                userDataUpdate()
                return;
            }

            const data = poly.userData as ShapeData,
                paths = poly.getPaths();

            if (!data || !paths || !paths.getLength()) {
                userDataUpdate()
                return;
            }

            const path = paths.getAt(0);
            const arrayPath = path.getArray();

            const violated = (typeName: string) => {
                return arrayPath.some(latLng => !isLatLngInsidePolygon(this.mapDrawer, latLng, typeName));
            }
            
            if (data && path && path.getLength() && data.dragPosition) {
                const currentPos = LatLng.FromGMLatLng(path.getAt(0)),
                    delta = currentPos.sub(data.dragPosition);

                if(poly.userData.typeName === window.AreaTypeName) {
                    // ---- All free areas and interferences should be inside area ----
                    const isOutsideFreeArea= violated(window.FreeAreaTypeName);
                    const isOutsideInterference = violated(window.InterfernceTypeName);
                    
                    if(isOutsideFreeArea || isOutsideInterference) {
                        poly.setPaths(dragInfo.initialPath);
                        return
                    }
                }

                // ---- Shape should not be outside area ----
                const isOutside =  violated(window.AreaTypeName)

                if(isOutside) {
                    poly.setPaths(dragInfo.initialPath);
                    return
                }

                // ---- Free Areas should not overlap ----
                const freeArea = this.mapDrawer.viewModel.layer.freeArea;
                if(poly.userData.typeName === window.FreeAreaTypeName && freeArea && freeArea.polygons.length) {
                    const currPoly = new google.maps.Polygon({paths: poly.getPaths().getAt(0)});

                    const isOverlapped = freeArea.polygons.some(areaPoly => {
                        if (areaPoly.userData.id === poly.userData.id) return false;

                        const otherPath = areaPoly.getPaths().getAt(0);
                        const otherPoly = new google.maps.Polygon({ paths: otherPath });

                        return polygonsOverlap(currPoly, otherPoly);
                    });
                    
                    if(isOverlapped) {
                        poly.setPaths(dragInfo.initialPath);
                        return
                    }
                }

                const mover = (sel: any) => {
                    sel.moveByLatLng(delta);
                    if (sel instanceof ShapeData) sel.updateStyle();
                    sel.update();
                };

                const method = data.typeName === window.BuildingTypeName
                    ? this.foreachItem
                    : this.foreachSelected;

                method.call(this, mover, data.id);

                delete data.dragPosition;

                data.update();
                data.hovered = false;
                data.updateStyle();
            }
        }
    }

    export interface ISubModelView {
        template: string;
        name: string;
    }

    export class LayerHolder {
        constructor(mapDrawer: MapDrawer, editorMode: number) {

            switch (editorMode) {
                case MapDrawing.EditorModeEnum.Area:
                    {
                        this.all.push(this.area = this.referenceLayer = this.mainLayer = new PolygonLayer({
                            typeName: window.AreaTypeName,
                            layerName: window.AreaLayerName,
                            shapeStyle: { fillColor: "#a7ac00", strokeColor: "#2b4300" },
                            shapeHoveredStyle: { fillColor: "#a7ac00", strokeColor: "#2b4300" },
                            shapeSelectedStyle: { fillColor: "#486e00", strokeColor: "#2b4300" },
                            shapeSelectedHoveredStyle: { fillColor: "#486e00", strokeColor: "#2b4300" },
                            zIndex: 1,
                            maxCount: 1
                        }, mapDrawer));

                        this.all.push(this.interference = this.area.child = new PolygonLayer({
                            typeName: window.InterfernceTypeName,
                            layerName: window.InterfernceLayerName,
                            shapeStyle: { fillColor: "#07AC00", strokeColor: "#0B3818" },
                            shapeHoveredStyle: { fillColor: "#07AC00", strokeColor: "#0B3818" },
                            shapeSelectedStyle: { fillColor: "#135B27", strokeColor: "#0B3818" },
                            shapeSelectedHoveredStyle: { fillColor: "#135B27", strokeColor: "#0B3818" },
                            zIndex: 6,
                            parent: this.area
                        }, mapDrawer));
                    }
                    break;
                case MapDrawing.EditorModeEnum.FreeArea:
                    {
                        this.all.push(this.area = this.referenceLayer = new PolygonLayer({
                            typeName: window.AreaTypeName,
                            layerName: window.AreaLayerName,
                            shapeStyle: { fillColor: "#b5b5b5", strokeColor: "#9e0808", fillOpacity: 0.1 },
                            shapeHoveredStyle: { fillColor: "#b5b5b5", strokeColor: "#9e0808", fillOpacity: 0.1 },
                            shapeSelectedStyle: { fillColor: "#dbdbdb", strokeColor: "#9e0808", fillOpacity: 0.4 },
                            shapeSelectedHoveredStyle: { fillColor: "#dbdbdb", strokeColor: "#9e0808", fillOpacity: 0.4 },
                            zIndex: 1,
                            maxCount: 1,
                            isPassive: true,
                        }, mapDrawer));

                        this.all.push(this.freeArea = this.mainLayer = this.area.child = new PolygonLayer({
                            typeName: window.FreeAreaTypeName,
                            layerName: window.FreeAreaLayerName,
                            shapeStyle: { fillColor: "#00ac73", strokeColor: "#053133" },
                            shapeHoveredStyle: { fillColor: "#00ac73", strokeColor: "#053133" },
                            shapeSelectedStyle: { fillColor: "#32cf93", strokeColor: "#053133" },
                            shapeSelectedHoveredStyle: { fillColor: "#32cf93", strokeColor: "#053133" },
                            zIndex: 2,
                            parent: this.area
                        }, mapDrawer));

                        this.all.push(this.interference = this.freeArea.child = new PolygonLayer({
                            typeName: window.InterfernceTypeName,
                            layerName: window.InterfernceLayerName,
                            shapeStyle: { fillColor: "#314570", strokeColor: "#0b1221" },
                            shapeHoveredStyle: { fillColor: "#314570", strokeColor: "#0b1221" },
                            shapeSelectedStyle: { fillColor: "#133d9c", strokeColor: "#0b1221" },
                            shapeSelectedHoveredStyle: { fillColor: "#133d9c", strokeColor: "#0b1221" },
                            zIndex: 6,
                            parent: this.freeArea
                        }, mapDrawer));
                    }
                    break;
                default: //roof/building
                    {
                        this.all.push(this.building = this.referenceLayer = this.mainLayer = new PolygonLayer({
                            typeName: window.BuildingTypeName,
                            layerName: window.BuildingLayerName,
                            shapeStyle: { fillOpacity: 0 },
                            shapeHoveredStyle: { fillOpacity: 0 },
                            shapeSelectedStyle: { fillOpacity: 0 },
                            shapeSelectedHoveredStyle: { fillOpacity: 0 },
                            zIndex: 4,
                            maxCount: 0
                        }, mapDrawer));

                        this.all.push(this.roof = this.building.child = new PolygonLayer({
                            typeName: window.RoofTypeName,
                            layerName: window.RoofLayerName,
                            zIndex: 3,
                            parent: this.building,
                            controlledByParent: true
                        }, mapDrawer));

                        this.all.push(this.interference = this.roof.child = new PolygonLayer({
                            typeName: window.InterfernceTypeName,
                            layerName: window.InterfernceLayerName,
                            shapeStyle: { fillColor: "#07AC00", strokeColor: "#0B3818" },
                            shapeHoveredStyle: { fillColor: "#07AC00", strokeColor: "#0B3818" },
                            shapeSelectedStyle: { fillColor: "#135B27", strokeColor: "#0B3818" },
                            shapeSelectedHoveredStyle: { fillColor: "#135B27", strokeColor: "#0B3818" },
                            zIndex: 6,
                            parent: this.roof
                        }, mapDrawer));
                    }
                    break;
            }

            Object.keys(this).forEach(k => {
                if (k && this[k] && this[k] instanceof PolygonLayer) {
                    var l = this[k] as PolygonLayer;
                    this.typeName[l.typeName] = l;
                }
            });
        }

        referenceLayer: PolygonLayer = null;
        mainLayer: PolygonLayer = null;
        area: PolygonLayer = null;
        building: PolygonLayer = null;
        roof: PolygonLayer = null;
        roofArea: PolygonLayer = null;
        freeArea: PolygonLayer = null;
        interference: PolygonLayer = null;

        typeName: { [typeName: string]: PolygonLayer } = {};

        all: PolygonLayer[] = [];
    }

}
